import { render } from "./FormUser.vue?vue&type=template&id=054f30ab"
import script from "./FormUser.vue?vue&type=script&lang=js"
export * from "./FormUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__